import { File, FileNameTypes, FileUploadStatus, ReportDetailsQuery } from '@/__generated__/graphql';
import { SelectableImage } from '../SelectableImage';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import { Dispatch, SetStateAction, useMemo } from 'react';

type Props = {
  pois: ReportDetailsQuery['report']['pointOfInterests'];
  reportFiles: ReportDetailsQuery['report']['files'];
  setImagesToAttach: Dispatch<SetStateAction<File[]>>;
  imagesToAttach: File[];
};
export const UnattachedImages = ({
  pois,
  setImagesToAttach,
  imagesToAttach,
  reportFiles,
}: Props) => {
  const allPoiImages = useMemo(() => {
    const attachments: File[] = (pois ?? [])?.flatMap((poi) => {
      return (poi.files ?? [])?.filter(({ uploadStatus, name }) => {
        if (uploadStatus !== FileUploadStatus.Success) return false;
        return name === FileNameTypes.PoiAttachments;
      });
    });

    return attachments;
  }, [pois]);

  return (
    <>
      {(allPoiImages || [])

        // all POI images that we're not found in the report files
        .filter(
          (file) =>
            !reportFiles?.some((reportFile) => reportFile.resourcePath === file.resourcePath)
        )

        .map((file) => {
          return (
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <SelectableImage
                imgProps={{
                  src: getCloudfrontUrl(file.resourcePath),
                  width: '100%',
                }}
                overlayVisible={Boolean(imagesToAttach?.some((item) => item.id === file.id))}
                onClick={() => {
                  setImagesToAttach((prev) => {
                    const imageIndex = prev.findIndex((f) => f.id === file.id);
                    if (imageIndex === -1) {
                      return [...prev, file];
                    }
                    return prev.filter((_, i) => i !== imageIndex);
                  });
                }}
              />
            </div>
          );
        })}
    </>
  );
};
